import { observer } from "mobx-react";
import FontBody1 from "../../../../../../components/fonts/font-body1/font-body1";
import { FONT_COLOR, FONT_VARIANT } from "../../../../../../components/fonts/font-props";
import { FormFieldLine } from "../../../../../../components/form-field-line/form-field-line";
import { SelectDropdown } from "../../../../../../components/inputs/select-dropdown/select-dropdown";
import { Toggle } from "../../../../../../components/inputs/toggle/toggle";
import Card from "../../../../../../components/layouts/card/card";
import { imageOptionList, IMAGE_OPTION, IMAGE_OPTION_MAP, RESOLUTION_ID } from "../../../../constants";
import { IResolutionTypeProps } from "../resolution-type-viewer-props";



const Custom: React.FC<IResolutionTypeProps> = observer(({ resolution, validationGroup }) => {
    const selectedImage = IMAGE_OPTION_MAP[resolution?.image as IMAGE_OPTION] ?? IMAGE_OPTION_MAP[IMAGE_OPTION.OPTIONAL];
    const cardTitle = resolution?.resolutionId === RESOLUTION_ID.MANUAL_EXCHANGE ? 'Image' : 'Refund';

    return (
        <Card
            toolbar={{
                title: <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>{cardTitle}</FontBody1>,
            }}
        >
            {resolution?.resolutionId === RESOLUTION_ID.MANUAL_EXCHANGE
                ?
                <FormFieldLine
                    label="Request Image"
                >
                    <SelectDropdown
                        value={selectedImage}
                        options={imageOptionList()}
                        onChange={(v) => {
                            if (v) {
                                resolution?.setImage(v.value as number);
                            }
                        }}
                        required
                        validationGroup={validationGroup} />
                </FormFieldLine>
                :
                <FormFieldLine
                    label="Automatic refund"
                    note={'Set whether you refund canceled orders automatically or manually'}
                >
                    <Toggle
                        checked={!!resolution?.allowAutoRefund}
                        label=""
                        onChange={(v) => resolution?.setAllowAutoRefund(v)}
                    />
                </FormFieldLine>
            }
        </Card>
    )
});

export default Custom;